"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rightArrow = exports.bottomArrow = exports.emptyCheckbox = exports.indeterminateCheckbox = exports.checkedCheckbox = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var _token = require("@jarvis/token");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var checkedCheckbox = /*#__PURE__*/ (0, _jsxRuntime).jsxs("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime).jsx("rect", {
            width: "12",
            height: "12",
            rx: "2",
            fill: _token.COLOR_BRAND_4_DEFAULT
        }),
        /*#__PURE__*/ (0, _jsxRuntime).jsx("path", {
            d: "M2 5.25L4.5 8.25L10.5 3.75",
            stroke: "white",
            strokeWidth: "1.5"
        })
    ]
});
exports.checkedCheckbox = checkedCheckbox;
var indeterminateCheckbox = /*#__PURE__*/ (0, _jsxRuntime).jsxs("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime).jsx("rect", {
            width: "12",
            height: "12",
            rx: "2",
            fill: _token.COLOR_BRAND_4_DEFAULT
        }),
        /*#__PURE__*/ (0, _jsxRuntime).jsx("path", {
            d: "M2.49878 6.5225L9.99874 6.49902",
            stroke: "white",
            strokeWidth: "1.5"
        })
    ]
});
exports.indeterminateCheckbox = indeterminateCheckbox;
var emptyCheckbox = /*#__PURE__*/ (0, _jsxRuntime).jsx("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxRuntime).jsx("rect", {
        x: "0.5",
        y: "0.5",
        width: "11",
        height: "11",
        rx: "1.5",
        fill: _token.COLOR_BG_CARD_1,
        stroke: _token.COLOR_TEXT_4
    })
});
exports.emptyCheckbox = emptyCheckbox;
var bottomArrow = /*#__PURE__*/ (0, _jsxRuntime).jsx("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxRuntime).jsx("path", {
        d: "M15 8L10 13L5 8",
        stroke: _token.COLOR_TEXT_5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
exports.bottomArrow = bottomArrow;
var rightArrow = /*#__PURE__*/ (0, _jsxRuntime).jsx("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxRuntime).jsx("path", {
        d: "M8 5L13 10L8 15",
        stroke: _token.COLOR_TEXT_5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })
});
exports.rightArrow = rightArrow;
